import Card from '../../../components/ui/Card';

/**
 * Assets overview card for the site details page. Display-only.
 */
export default function SiteDetailsAssetsOverview({
  assetsOverview,
  elementTypeLabels,
}) {
  return (
    <Card style={{ marginBottom: '1.5rem' }}>
      <h3 className="card-title">Assets overview</h3>
      <div style={{ display: 'flex', gap: '2rem', flexWrap: 'wrap' }}>
        <div>
          <span className="text-muted">Total assets: </span>
          <strong>{assetsOverview.total}</strong>
        </div>
        <div>
          <span className="text-muted">{elementTypeLabels.electrical ?? 'Electrical'}: </span>
          <strong>{assetsOverview.electrical}</strong>
        </div>
        <div>
          <span className="text-muted">{elementTypeLabels.fitments ?? 'Workshop Equipment'}: </span>
          <strong>{assetsOverview.fitments}</strong>
        </div>
      </div>
    </Card>
  );
}
